import { render, staticRenderFns } from "./McLayoutFullwidth.vue?vue&type=template&id=5c32b836"
import script from "./McLayoutFullwidth.vue?vue&type=script&lang=js"
export * from "./McLayoutFullwidth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports